<!-- prettier-ignore -->
<app-calendar 
  #calendar 
  
  [date]="today" 
  [eventHandler]="handleEventRequest" 
  [dayTemplate]="dayTemplate"
  (eventClick)="currentClickEvent = $event; modalService.open(dayClickModal); dayClicked(calendar, $event)">
</app-calendar>

<!--Week seperate component-->
<h1>Week</h1>

<!-- Prettier, can you not? -->
<!-- prettier-ignore -->
<app-calendar-week
  [date]="today"
  [settings]="{
    disableHighlightToday: true,
    disableWeekendsGrey: true,
    disablePastDaysGrey: true,
    disableDaySelect: true,
    disableDaySelectMultiple: true,
    disableEventHover: true
  }"
></app-calendar-week>

<!--Month seperate component-->
<h1>Month</h1>
<app-calendar-month [date]="today"></app-calendar-month>

<!--Year seperate component-->
<h1>Year</h1>
<app-calendar-year [date]="today"></app-calendar-year>

<!--Example of replacing the events with custom content.-->
<ng-template #dayTemplate let-calendarEvent="calendarEvent" let-date="date" let-default="default">
  <ng-container [ngSwitch]="calendarEvent.data">
    <!--Example 1: Replace the entire day container with custom content.-->
    <div *ngSwitchCase="0" class="bg-progreso rounded p-1 text-white">I am a custom day template for {{ calendarEvent?.label }}!</div>

    <!--Example 2: Replace ONLY the content inside the container with custom content.-->
    <ng-container *ngSwitchCase="1" [ngTemplateOutlet]="default" [ngTemplateOutletContext]="{ calendarEvent: calendarEvent, date: date, customTextTmpl: customText }"></ng-container>

    <!--For all other instances, render the default template.-->
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="default" [ngTemplateOutletContext]="{ calendarEvent: calendarEvent, date: date }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #customText let-calendarEvent="calendarEvent" let-date="date">
  <span>I am custom text!</span>
</ng-template>

<ng-template #dayClickModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Example modal</h4>
  </div>
  <div class="modal-body">You clicked on day: {{ currentClickEvent.context.label }}</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Close</button>
  </div>
</ng-template>
